import { render } from "./About.vue?vue&type=template&id=3654185e"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=3654185e&lang=scss"

import exportComponent from "/Users/devgroup/work/hanbyul/hanbyeol/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__